import React, { Component } from 'react';
import { Spin } from 'antd';

class Loader extends Component {
    render() {
        const { loaderClassname } = this.props;
        return (
            <div className={`text-center  items-center page-loading ${loaderClassname}`}><Spin size="large" tip="Loading..." /></div>
        );
    }
}
export default Loader;